import { Promise } from "@securionpay-internal/commons-js";

export default function (): Promise<typeof document.body> {
    return new Promise((resolve) => {
        if (document.body) {
            resolve(document.body);
        } else {
            document.addEventListener("DOMContentLoaded", () => resolve(document.body));
        }
    });
}